module.exports = __webpack_public_path__ + "img/zdd_invite_lz_1.55b5986d.png";